import { useTableActionContext } from '@aibees/elephant/context/table-action/context';
import { SearchModality } from '@aibees/elephant/feature/search-table-company/hooks/types';
import { useGetCreditsAmountTypeOnActionPopup } from '@aibees/elephant/hooks/use-get-credits-amount-type-on-action-popup';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { BulkPanelGuidanceSavedProps as Props } from './types';

export const BulkPanelGuidanceSaved = memo(({ className }: Props) => {
  const { basicPeople, aiPeople } = useGetCreditsAmountTypeOnActionPopup();
  // Effective modality: for a single-record flow this follows the record's own
  // saved state rather than whichever tab the table is on.
  const { effectiveModality } = useTableActionContext();

  const shouldShow = useMemo(() => {
    return (
      (basicPeople || aiPeople) && effectiveModality === SearchModality.SAVED
    );
  }, [basicPeople, aiPeople, effectiveModality]);

  if (!shouldShow) return null;

  return (
    <Styled.Wrapper
      className={classnames('BulkPanelGuidanceSaved', className)}
      sx={SX.root}
      severity="default"
      variant="outlined"
    >
      <Typography variant="body4" fontWeight={400} color="grey.600">
        Update saved records before continuing. Saved Records uses the data
        currently stored for each contact. To use the latest Work History / Job
        Change or Profile Insights, close this panel, open Enrich, and run
        Update All or the specific update action you need. Then reopen this
        panel to continue.
      </Typography>
    </Styled.Wrapper>
  );
});

BulkPanelGuidanceSaved.displayName = 'BulkPanelGuidanceSaved';
